module.exports = __webpack_public_path__ + "img/Rubin.d7a42f26.png";